type EnumValue<T extends string | number | bigint | boolean | null | undefined> = `${T}`

//
// CHECKOUT EVENTS
//
export enum CheckoutEvents {
    // Klaviyo
    IS_SUBSCRIBING_KLAVIYO_EMAIL = "CHECKOUT.IS_SUBSCRIBING_KLAVIYO_EMAIL",

    // Customer Information
    SAME_SHIPPING_ADDRESS_CHANGED = "CHECKOUT.SAME_SHIPPING_ADDRESS_CHANGED",

    PAYMENT_RESULT_EVENT = "CHECKOUT.PAYMENT_RESULT_EVENT"
}

export type CheckoutEventsType = EnumValue<CheckoutEvents>

export type EventTypes = string | CheckoutEventsType

export interface EventsHandler {
    get: (event: EventTypes) => undefined | Record<number, Function>
    subscribe: (event: EventTypes, callback: Function) => number | undefined
    trigger: <E extends EventTypes>(event: E, ...args: any[]) => void
    unsubscribe: (event: EventTypes, handle: number) => undefined | boolean
}
